import React, { useContext, useMemo } from 'react';
import { Select } from 'antd';

import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';
import RemoteAccessDashboardContext from '@totem/components/services/remoteAccess/v2/summary/remoteAccessDashboardContext';
import OrganizationContext from '@totem/components/userContext/organizationContext/organizationContext';
import { isNull } from '@totem/utilities/common';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

const PropertySelector = () => {
  const { buildings } = useContext(OrganizationContext);
  const { onBuildingChange, selectedPropertyId } = useContext(
    RemoteAccessDashboardContext,
  );

  const buildingOptions = useMemo(() => {
    const defaultOption = {
      label: 'All Properties',
      value: EMPTY_ID,
    };

    if (isNull(buildings)) {
      return [defaultOption];
    }

    return [
      defaultOption,
      ...buildings
        .sort((compA, compB) => sortStringAscending(compA.name, compB.name))
        .map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        }),
    ];
  }, [buildings]);

  const handleBuildingChange = (bulidingId: string) => {
    onBuildingChange(bulidingId);
  };

  return (
    <Select
      value={selectedPropertyId}
      options={buildingOptions}
      onChange={handleBuildingChange}
      style={{ minWidth: '200px' }}
    />
  );
};

export default PropertySelector;
